import React from 'react';
import { connect } from 'react-redux';
import { logError } from '../ducks/error-logging-api';
import { LoggingError } from '../models/error-model';
import { ReactErrorFallbackContent } from './react-error-fall-back-content';


interface IDispatchProps {
	logError: (error: LoggingError) => any,
}

interface IState {
	hasError: boolean,
}

class ErrorBoundary extends React.Component<IDispatchProps, IState>{
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		this.props.logError({
			url: window.location.href,
			action: 'ReactRender',
			clientId: 'Need to get client ID',
			time: new Date(),
			errorMessage: 'Error Rendering react componet.',
			errorDetail: `${error.message}: ${errorInfo.componentStack}`,
			nonNetwork: true,
		});
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<ReactErrorFallbackContent />
			);
		}

		return this.props.children;
	}
}

const mapDispatchToProps = (dispatch): IDispatchProps => {
	return {
		logError: (error) => {
			dispatch(logError(error));
		},
	};
};


export const ErrorBoundaryApp = connect<IDispatchProps>(null, mapDispatchToProps)(ErrorBoundary as any);